(() => {
  if (customElements.get('ov-pdp-purchase')) return;
  customElements.define('ov-pdp-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = Array.from(document.querySelectorAll('[data-ov-atelier]')).find(root => root.dataset.productHandle === this.dataset.productHandle);
      if (!this.root) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.main = this.querySelector('[data-ov-purchase-main]');
      this.sticky = this.querySelector('[data-ov-purchase-sticky]');
      this.upload = this.root.querySelector('.ov-upload');
      this.variant = this.root.querySelector('[data-bound-variant]');
      this.form = this.root.querySelector('[data-product-form]');
      this.cart = this.root.querySelector('[data-custom-atc]');
      this.rules = JSON.parse(this.querySelector('[data-ov-quantity-rules]').textContent);
      this.quantity = this.querySelector('[data-ov-quantity]').value;
      this.addEventListener('input', event => {
        if (event.target.matches('[data-ov-quantity]')) this.setQuantity(event.target.value);
      }, options);
      this.addEventListener('click', event => {
        if (!event.target.closest('[data-ov-purchase-entry]')) return;
        event.preventDefault();
        this.setQuantity(this.quantity);
        this.goToUpload(true);
      }, options);
      if (document.documentElement.dataset.ovBridge === 'true') this.closest('product-info').dataset.updateUrl = 'false';
      document.addEventListener('variant:changed', event => {
        const id = String(event.detail?.variant?.id || '');
        if (document.documentElement.dataset.ovBridge === 'true' && this.rules[id]) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState(window.history.state, '', url);
          requestAnimationFrame(() => this.goToUpload(true));
        }
        if (!Array.from(this.variant.options).some(option => option.value === id) || this.variant.value === id) return;
        this.variant.value = id;
        this.variant.dispatchEvent(new Event('change', { bubbles: true }));
      }, options);
      document.addEventListener('click', event => {
        const button = event.target.closest('[data-add-bundle]');
        const bundle = button?.closest('m-product-bundle');
        if (!bundle || !Array.from(bundle.querySelectorAll('[data-product-handle]')).some(item => item.dataset.productHandle === this.dataset.productHandle)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.goToUpload();
      }, { ...options, capture: true });
      this.variant.addEventListener('change', () => {
        this.setQuantity(this.quantity);
        if (document.documentElement.dataset.ovBridge === 'true' && this.rules[this.variant.value]) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', this.variant.value);
          window.history.replaceState(window.history.state, '', url);
        }
        const title = this.variant.selectedOptions[0]?.dataset.title;
        const info = document.getElementById('ProductInfo-' + this.dataset.sectionId) || this.closest('product-info');
        const radio = Array.from(info?.querySelectorAll('variant-picker input[type="radio"]') || []).find(input => input.value === title);
        if (radio && !radio.checked) radio.click();
      }, options);
      this.root.addEventListener('ov:attachment', () => this.updateGate(), options);
      this.root.addEventListener('ovlight:cart-added', () => this.updateGate(), options);
      this.observer = new MutationObserver(() => this.updateGate());
      this.observer.observe(this.root, { attributes: true, attributeFilter: ['data-cart-state', 'data-persistence-status'] });
      this.intersection = new IntersectionObserver(() => this.updateSticky());
      this.intersection.observe(this.main);
      this.intersection.observe(this.upload);
      window.addEventListener('scroll', () => this.updateSticky(), { ...options, passive: true });
      window.addEventListener('resize', () => this.updateSticky(), options);
      this.setQuantity(this.quantity);
      this.updateGate();
      if (document.documentElement.dataset.ovBridge === 'true') {
        const land = () => this.goToUpload(true);
        if (document.readyState === 'complete') requestAnimationFrame(land);
        else window.addEventListener('load', land, { ...options, once: true });
      }
    }
    setQuantity(value) {
      const rule = this.rules[this.variant.value] || { min: 1, increment: 1 };
      const min = rule.min || 1, step = rule.increment || 1;
      let quantity = Math.max(min, Math.floor(Number(value) || min));
      if (rule.max != null) quantity = Math.min(quantity, rule.max);
      quantity = min + Math.floor((quantity - min) / step) * step;
      this.quantity = String(quantity);
      this.querySelectorAll('[data-ov-quantity]').forEach(input => {
        input.min = min; input.step = step; input.value = this.quantity;
        if (rule.max != null) input.max = rule.max; else input.removeAttribute('max');
      });
      this.form.elements.namedItem('quantity').value = this.quantity;
    }
    goToUpload(includeContext = false) {
      const headers = Array.from(document.querySelectorAll('header, .m-header')).filter(header => {
        const rect = header.getBoundingClientRect(), position = getComputedStyle(header).position;
        return ['sticky', 'fixed'].includes(position) && rect.top < 120 && rect.bottom > 0;
      });
      const offset = Math.max(90, ...headers.map(header => header.getBoundingClientRect().bottom)) + 16;
      const target = includeContext ? this.form : this.upload;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      this.sticky.hidden = true;
      this.upload.classList.add('ov-pdp-upload-focus');
      (includeContext ? this.variant : this.root.querySelector('[data-photo-upload]')).focus({ preventScroll: true });
      window.scrollTo({ top, behavior: includeContext || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      clearTimeout(this.highlightTimer);
      this.highlightTimer = setTimeout(() => this.upload.classList.remove('ov-pdp-upload-focus'), 2500);
    }
    updateGate() {
      const verified = this.root.dataset.cartState === 'verified';
      this.querySelectorAll('[data-ov-quantity]').forEach(input => { input.disabled = verified || this.variant.disabled; });
      const ready = this.root.dataset.persistenceStatus === 'ready' && this.root.dataset.customizationId && !this.cart.disabled;
      this.querySelectorAll('[data-ov-purchase-entry]').forEach(entry => {
        entry.textContent = 'Customize your lamp';
      });
      this.querySelector('[data-ov-payment-help]').textContent = ready
        ? 'Your design is saved. Continue to secure checkout.'
        : 'Complete your customization to unlock secure checkout.';
      this.updateSticky();
    }
    updateSticky() {
      const main = this.main.getBoundingClientRect(), upload = this.upload.getBoundingClientRect();
      this.sticky.hidden = window.innerWidth > 767 || upload.top < window.innerHeight || (main.bottom > 0 && main.top < window.innerHeight);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); clearTimeout(this.highlightTimer);
    }
  });
})();
